
export const actions = {

  async setProfile ({commit, dispatch}, profile) {
    await commit('SET_LIFF_PROFILE', profile)
    await dispatch('memberStore/getMemberProfileForSet', {}, { root: true })
    return true
  }
  // async liffInit ({commit, state}) {
  //   try {
  //     if (!state.liffReady) {
  //       await Vue.prototype.$liff.init({
  //         liffId: Vue.prototype.$liffId
  //       }).then(async () => {
  //         commit('SET_LIFF_READY', true)
  //       }).catch((err) => {
  //         console.log(err.code, err.message)
  //       })
  //     }
  //     return
  //   } catch (error) {
  //     console.log('liffInit error', error.message)
  //     return null
  //   }
  // },
  // async liffGetProfile ({commit, state, dispatch}) {
  //   try {
  //     if (state.liffReady) {
  //       if (!state.liffProfile) {
  //         // if (process.env.NODE_ENV === 'development') {
  //         //   const profile = Vue.prototype.$profile_dev
  //         //   dispatch('memberStore/getMemberProfile', profile.userId, { root: true })
  //         //   commit('SET_LIFF_PROFILE', profile)
  //         // } else {
  //         if (!Vue.prototype.$liff.isLoggedIn()) {
  //           await Vue.prototype.$liff.login({redirectUri: window.location.href})
  //         } else {
  //           await Vue.prototype.$liff.getProfile().then(async (profile) => {
  //             await commit('SET_LIFF_PROFILE', profile)
  //             await dispatch('memberStore/getMemberProfile', {}, { root: true })
  //           }).catch(function (error) {
  //             console.log('Error getting profile: ' + error)
  //           })
  //         }
  //         // }
  //       }
  //     }
  //   } catch (error) {
  //     console.log('liffGetProfile error', error.message)
  //     return null
  //   }
  // }
}



// WEBPACK FOOTER //
// ./src/store/line/actions.js